// extracted by mini-css-extract-plugin
export default {"myApps":"MyApps_myApps__kZcRZ","title":"MyApps_title__tpMmv","preloaderWrapper":"MyApps_preloaderWrapper__garcc"};